/*
  Purely visual "fly to cart" effect on add-to-cart submit.
  Does not touch the actual add-to-cart request/logic (Dawn's product-form.js
  already handles that) - this only clones the product image and animates it
  toward the cart icon, then removes itself.
*/
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function getCartIconEl() {
    return (
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.cart-icon') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[id^="cart-icon"]')
    );
  }

  function findProductImage(form) {
    var container = form.closest('.product') || form.closest('[data-section-type]') || document;
    var img = container.querySelector('.product__media img, .product-media-container img, img');
    return img;
  }

  function flyToCart(sourceImg) {
    var cartIcon = getCartIconEl();
    if (!cartIcon || !sourceImg) return;

    var startRect = sourceImg.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();
    if (!startRect.width || !endRect.width) return;

    var clone = sourceImg.cloneNode(true);
    clone.style.position = 'fixed';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.margin = '0';
    clone.style.borderRadius = '4px';
    clone.style.objectFit = 'cover';
    clone.style.zIndex = '10001';
    clone.style.pointerEvents = 'none';
    clone.style.transition = 'transform 0.7s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.7s ease, width 0.7s ease, height 0.7s ease';
    clone.style.willChange = 'transform, opacity';
    document.body.appendChild(clone);

    var endX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    var endY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + endX + 'px, ' + endY + 'px) scale(0.15)';
        clone.style.opacity = '0.15';
      });
    });

    window.setTimeout(function () {
      clone.remove();
      cartIcon.classList.add('zed-cart-icon-pulse');
      window.setTimeout(function () {
        cartIcon.classList.remove('zed-cart-icon-pulse');
      }, 350);
    }, 720);
  }

  var style = document.createElement('style');
  style.textContent =
    '@keyframes zed-cart-pulse { 0% { transform: scale(1); } 40% { transform: scale(1.25); } 100% { transform: scale(1); } }' +
    '.zed-cart-icon-pulse { animation: zed-cart-pulse 0.35s ease; display: inline-block; }';
  document.head.appendChild(style);

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var img = findProductImage(form);
      if (img) flyToCart(img);
    },
    true
  );
})();
